import { useContext, useEffect } from "react"
import { NotificationContext } from "../contexts/NotificationContexts"
import { useTranslation } from "react-i18next"



export const PageHeader = ({pageTitle}) => {
    const { t } = useTranslation('common')
    const { numberNotifications } = useContext(NotificationContext)
    
    useEffect(() => {
        document.title = numberNotifications 
        ? `(${numberNotifications}) ${pageTitle} - Mobile2 ${t('Support')}`
        : `${pageTitle} - Mobile2 ${t('Support')}`
    }, [pageTitle, numberNotifications])
    return null
}